import React, { useState, useEffect } from "react";
import { FaInstagram } from "react-icons/fa";
import "../styles/Instagramwidget.css"

const INSTA_USERNAME = "stencils_world54";

const InstagramWidget = ({ inNavbar }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 600);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleOpenInstagram = () => {
    window.open(`https://instagram.com/${INSTA_USERNAME}`, "_blank");
  };

  return (
    <>
      {/* Floating Instagram FAB (Desktop only) */}
      {!inNavbar && !isMobile && (
        <button
          className="instagram-fab"
          aria-label="Open Instagram"
          onClick={handleOpenInstagram}
        >
          <FaInstagram size={28} />
        </button>
      )}

      {/* Instagram icon in Navbar (Mobile only) */}
      {inNavbar && isMobile && (
        <button
          className="instagram-navbar"
          aria-label="Open Instagram"
          onClick={handleOpenInstagram}
        >
          <FaInstagram size={18} style={{ color: "#fff" }} />
        </button>
      )}
    </>
  );
};

export default InstagramWidget;
